module.exports = __webpack_public_path__ + "img/18.heavy-rain-light.96b95949.svg";